import React, {useEffect} from 'react';
import { Modal } from 'react-bootstrap';
import '../../scss/popups/upload.scss';
import closeicon from '../../images/popups/upload/closeicon.png';
import uploadimage from '../../images/popups/upload/uploadimage.png';
import greyuploadimage from '../../images/popups/upload/greyuploadimage.png';
import fileicon from '../../images/popups/upload/fileicon.png';
import tickmark from '../../images/common/tick_mark.png';
import getResponse from '../actions/Project';
import { useState } from 'react';
import Progress from '../Reusables/Progress';
import { useNavigate } from "react-router-dom";
import RefreshToken from '../actions/RefreshToken';
import Snackbars from '../Reusables/Snackbar';

function Upload(props) {
    const { id, show, handleClose, setUpload, uploadstate, setLoadEnd, loadend, created, pageType } = props;
    const navigate = useNavigate();
    const [disbledstate, setDisbledstate] = useState(false);
    const [errormsg, setError] = useState(null);
    const [open, setOpen] = useState(null)

    const [multipleFiles , setMultipleFiles] = useState({
        selectedFiles: [],
        progressInfos: [],
        messages: []
    }); 
    const [progress, setProgress] = useState(null);
    const [fileCount, setFileCount] = useState(null);
    const [iterationCount, setIterationCount] = useState(0);

    useEffect(() => {
        setInitialValues();
    }, [created])

    const setInitialValues = () => {
        setProgress(null);
        setLoadEnd(false);
        setDisbledstate(false);
        setIterationCount(null);
        setFileCount(null)
        setMultipleFiles({
            selectedFiles: [],
            progressInfos: [],
            message: []
        })
    }

    function ShowFiles(e) {
        setInitialValues();

        if(e.target.files.length > 0) {
            var extensions = ["png", "jpeg", "jpg", "svg", "gif", "jfif", 'pdf'];
        
            for(let i = 0; i < e.target.files.length; i++) {
                if(e.target.files[i].name.lastIndexOf('.') !== -1) {
                    var extension = e.target.files[i].name.substring(e.target.files[i].name.lastIndexOf('.')+1, e.target.files[i].name.length);
                }
                else {
                    var extension = ''
                }

                if(e.target.files[i] && ((e.target.files[i].size / (1024 ** 2)).toFixed(2)) <= 75 && extensions.includes(extension.toLowerCase()) && e.target.files[i].name.length <= 90) {
                    //
                } else {
                    if(((e.target.files[i].size / (1024 ** 2)).toFixed(2)) > 75 && !extensions.includes(extension.toLowerCase())) {
                        document.getElementById('fileInput').value = null;  
                        setOpen(true);
                        setError(`File size is greater than 75MB and the ${extension} filetype is not supported`);
                        return;
                    } else if(((e.target.files[i].size / (1024 ** 2)).toFixed(2)) > 75) {
                        document.getElementById('fileInput').value = null;  
                        setOpen(true);
                        setError("File size is greater than 75MB");
                        return;
                    } else if(!extensions.includes(extension.toLowerCase())) {
                        document.getElementById('fileInput').value = null;  
                        setOpen(true);
                        setError(`The ${extension} filetype is not supported`);
                        return;
                    } else if(e.target.files[i].name.length > 90) {
                        document.getElementById('fileInput').value = null;  
                        setOpen(true);
                        setError(`Filename is too long`);
                        return;
                    }
                }
            }

            setDisbledstate(true);     
            setMultipleFiles({
                ...multipleFiles,
                selectedFiles: e.target.files,
                progressInfos: []
            })
        }
    };

    useEffect(() => {
        let _progressInfos = [];
        if(multipleFiles.selectedFiles.length > 0) {
            for(let i = 0; i < multipleFiles.selectedFiles.length; i++) {
                let fileSize = (multipleFiles.selectedFiles[i].size / (1024 ** 2)) >= 1 ? `${(multipleFiles.selectedFiles[i].size / (1024 ** 2)).toFixed(2)} MB` : `${(multipleFiles.selectedFiles[i].size / 1024).toFixed(2)} KB`;
                _progressInfos.push({percentage: 0, fileName: multipleFiles.selectedFiles[i].name, fileSize: fileSize})
            }

            setMultipleFiles({
                ...multipleFiles,
                progressInfos: _progressInfos,
                message: []
            })

            setProgress(0);
        }
    }, [multipleFiles.selectedFiles])

    useEffect(() => {
        if(progress == 0)
        for(let i = 0; i < multipleFiles.selectedFiles.length; i++) {
            upload(i, multipleFiles.selectedFiles[i]);
        }
    }, [progress])

    const upload = (idx, file) => {
        let _progressInfos = multipleFiles.progressInfos;
        
        let formData = new FormData();
        formData.set('file', file);
        formData.set('projectId', id);

        function CallAPI(accesstoken) {
            if(accesstoken === '') {
                navigate('/login');
            } else {
                getResponse.MultipleUploadFiles("/api/Project/broadcast/uploadfile", formData, accesstoken, (event) => {  
                    _progressInfos[idx].percentage = Math.round((100 * event.loaded) / event.total)
                    setMultipleFiles({
                        ...multipleFiles,
                        progressInfos: _progressInfos
                    })
                }).then((response) => {
                    if(multipleFiles.selectedFiles.length > idx) {
                        setFileCount(idx+1)
                    }
                }).catch((error) => {
                    if(error.response.status == 401) {
                        navigate("/login")
                    } else {
                        setError(`Couldn't upload the ${file.name} file`);
                        setOpen(true);
                        setDisbledstate(false);
                    }
                })
            }
        }
            RefreshToken((accesstoken) => CallAPI(accesstoken));
    }

    useEffect(() => {
        if(fileCount != null) {
            setUpload(!uploadstate);
            setIterationCount(iterationCount + 1)   
        }
    }, [fileCount])

    useEffect(() => {
        if(iterationCount != null) {
            if(iterationCount == multipleFiles.selectedFiles.length) {
                setLoadEnd(true);
                setDisbledstate(false);
                setMultipleFiles({
                    ...multipleFiles,
                    progressInfos: []
                })
            }
        }
    }, [iterationCount])

    return (
        <div>
            <Modal show={ show } onHide={ handleClose } >
                <Modal.Body className='upload-body'>
                    <div className='close-icon'>
                        <img src={closeicon} alt="closeicon" onClick={props.handleClose}></img>
                    </div>
                    <div className='upload-content'>
                        <h4>Upload Files<span className='file-size'>File size maximum 75 MB</span></h4>
                        <div className='upload-container'>
                            <div className='upload-sub-container'>
                                <input disabled={disbledstate} type='file' multiple className={disbledstate ? "file-conatiner disable" : "file-conatiner enable"} id='fileInput' name='file' onChange={(e) => ShowFiles(e)}></input>
                                <img src={disbledstate ? greyuploadimage : uploadimage} className='uploadimage'></img>
                                <div className='click-drag'> 
                                    <span className={disbledstate ? "click clickgrey" : "click clickblue"}>{(pageType == "Entities" || pageType == "Contacts") ? 'Click To Import' : 'Click To Upload'}{loadend ? ' More Files' : ''}</span>
                                    <span className={disbledstate ? "drag draggrey" : "drag dragblack"}>Or Drag and Drop Your file</span>
                                </div>
                            </div>
                        </div>
                        <div className='multi-files-progress-container'>
                            { multipleFiles.progressInfos.length > 0 &&
                                multipleFiles.progressInfos.map((file) => {
                                    return(
                                        <div className='progress-container'>
                                            <div className='progress-file-container'>
                                                <div className='progress-file'>
                                                    <img src={fileicon} alt='fileicon'></img>
                                                </div>
                                                <div className='multiple-name-size'>
                                                    <div className='file-name'>{file.fileName}</div>
                                                    <div className='file-size'>{file.fileSize}</div>
                                                </div>
                                                {file.percentage == 100 && 
                                                <div>
                                                    <img className='tickmark' src={tickmark} alt='tickmark'></img>
                                                </div>}
                                            </div>  
                                            {file.percentage != 100 && <Progress value={Number(file.percentage)} />}
                                        </div>
                                    )
                                })
                            }
                            { loadend &&
                                <div className='success'>Uploaded Successfully</div>
                            }
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            <Snackbars error={errormsg} open={open} setOpen={setOpen}/>
        </div>
    );
}

export default Upload;